<template>
  <div
    ref="alertModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">到期提醒</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            X
          </button>
        </div>
        <div class="modal-body">
          <table class="table table-bordered table-hover">
            <thead>
              <tr class="tr-bg">
                <th scope="col" class="text-nowrap" style="width: 40%">
                  專案名稱
                </th>
                <th scope="col" class="text-nowrap" style="width: 40%">
                  工作項目
                </th>
                <th scope="col" class="text-nowrap" style="width: 20%">
                  預定完成日
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in alertData" :key="index">
                <td class="text-truncate" style="max-width: 0">
                  {{ data.case_list.project_name }}
                </td>
                <td class="text-truncate" style="max-width: 0">
                  {{ data.job_name }}
                </td>
                <td class="text-truncate" style="max-width: 0">
                  {{ data.est_end }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn clear-btn" data-dismiss="modal">
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alertModal: null,
      alertData: [],
    };
  },
  props: {
    auth: {
      type: Boolean,
      default: false,
    },
    alertTodoUrl: {
      type: String,
      default: "",
    },
  },
  methods: {
    getAlertData() {
      const vm = this;
      if (!vm.auth) {
        return;
      }

      super_ajax({
        url: vm.alertTodoUrl,
        type: "GET",
        success: function (obj) {
          if (obj.success) {
            if (obj.data.length > 0) {
              vm.alertData = [...obj.data];
              vm.alertModal.show();
            }
          } else {
            alertModal("提示", "讀取發生錯誤");
          }
        },
        error: function (jqXHR, exception) {
          var msg = "";
          if (jqXHR.status === 0) {
            msg = "Not connect.\n Verify Network.";
          } else if (jqXHR.status == 404) {
            msg = "Requested page not found. [404]";
          } else if (jqXHR.status == 500) {
            msg = "Internal Server Error [500].";
          } else if (exception === "parsererror") {
            msg = "Requested JSON parse failed.";
          } else if (exception === "timeout") {
            msg = "Time out error.";
          } else if (exception === "abort") {
            msg = "Ajax request aborted.";
          } else {
            msg = "Uncaught Error.\n" + jqXHR.responseText;
          }
          alertModal("提示", msg);
        },
      });
    },
  },
  mounted() {
    this.alertModal = new bootstrap.Modal(this.$refs.alertModal);

    if (window.localStorage.getItem("fromLogin")) {
      window.localStorage.removeItem("fromLogin");
      const vm = this;
      $(function () {
        vm.getAlertData();
      });
    }
  },
};
</script>
